import { useState, useEffect } from 'react';
import { fetchSlotMonthlySales } from '../../../data/machinesApi';

// Monthly totals only change once a day, so a slot opened again in this session renders without a request
const cache = new Map();

const useSlotMonthlySales = (storeId, productId, clientId) => {
  const key = storeId && productId && clientId ? `${clientId}:${storeId}:${productId}` : null;
  const [fetched, setFetched] = useState({ key: null, data: null });

  useEffect(() => {
    if (!key || cache.has(key)) return;

    let cancelled = false;
    fetchSlotMonthlySales(clientId, storeId, productId)
      .then(result => {
        cache.set(key, result);
        if (!cancelled) setFetched({ key, data: result });
      })
      .catch(() => {
        if (!cancelled) setFetched({ key, data: null });
      });

    return () => { cancelled = true; };
  }, [key, clientId, storeId, productId]);

  if (!key) return { data: null, loading: false };
  if (cache.has(key)) return { data: cache.get(key), loading: false };
  return { data: fetched.key === key ? fetched.data : null, loading: fetched.key !== key };
};

export default useSlotMonthlySales;
